import React, { useRef, useEffect } from "react";
import {
  motion,
  useAnimation,
  useTransform,
  useScroll,
  useInView
} from "framer-motion";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './product_sstyle.css';
import './productdetails.css';
import { FiArrowRight } from "react-icons/fi";

// ScrollLine animations
const fadeInUpq = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 }
};
const fadeInLeftq = {
  hidden: { opacity: 0, x: -150 },
  visible: { opacity: 1, x: 0 }
};
const fadeInRightq = {
  hidden: { opacity: 0, x: 0 },
  visible: { opacity: 1, x: -100 }
};

// ScrollLine component
function ScrollLine({ children, animation }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: false });

  return (
    <div className="scroll-panel" ref={ref}>
      <motion.h2
        initial={animation?.hidden || { opacity: 0, y: 30 }}
        animate={inView ? (animation?.visible || { opacity: 1, y: 0 }) : {}}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        {children}
      </motion.h2>
    </div>
  );
}

function Productdetailsframer() {
  const section1Ref = useRef(null);
  const imageRef1 = useRef(null);
  const imageRef2 = useRef(null);

  // Scroll-based animation for section 1
  const { scrollYProgress } = useScroll({
    target: section1Ref,
    offset: ["start start", "end start"]
  });
  const yTransform = useTransform(scrollYProgress, [0, 1], ["0%", "-10%"]);
  const yTransform1 = useTransform(scrollYProgress, [0, 1], ["40%", "-500%"]);

  // Variants
  const containerVariants = {
    // hidden: {},
    // visible: {
    //   transition: {
    //     staggerChildren: 0.5,
    //   }
    // }
  };

  const childrenVariantsone = {
  hidden: {
    scale: 1,
    opacity: 0,
    y: "200vh", // was 200px
  },
  visible: {
    scale: 1,
    opacity: 1,
    y: "-10vh",
    transition: {
      duration: 1,
      mass: 1.5,
      stiffness: 200,
    }
  }
};

  const childrenVariantstwo = {
  hidden: {
    scale: 1,
    opacity: 0,
    y: "30vh",
  },
  visible: {
    scale: 1,
    opacity: 1,
    y: "-10vh",
    transition: {
      duration: 1,
      delay: 0.5, // <-- added delay
      mass: 1.5,
      stiffness: 200,
    },
  },
};



  // Animation + InView controls
  const animatedRef = useRef(null);
  const inView = useInView(animatedRef, { threshold: 0.2 });
  const controls = useAnimation();

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    } else {
      controls.start("hidden");
    }
  }, [inView, controls]);

  return (
    <>
      {/* Custom InView Animated Section */}
      <div className="text-holder scroll-section" ref={animatedRef}>
        <motion.div
          className="text-inner fixed-content-ani container"
          variants={containerVariants}
          initial="hidden"
          animate={controls}
        >
          <motion.div className="page-title" variants={childrenVariantsone} initial="hidden"
  whileInView="visible"
  viewport={{ once: false, amount: 0.2 }} layout>
            <h3 className="pt-5">What is it?</h3>
          <p>
            Speaklear™ is a self learning speech training application software that
            can be used by individuals as well as speech therapists for their speech
            therapy.
          </p>
          </motion.div>
          <motion.div className="intro-paragraph" variants={childrenVariantstwo} initial="hidden"
  whileInView="visible"
  viewport={{ once: false, amount: 0.2 }} layout>
            <div className="scroll-para">
              <h3 className="pt-5">What are we doing?</h3>
              <p>We are the first player in the digital assistive speech training space for people with speech impairments. We tackle conventional challenges of speech therapy by providing a digital tool that facilitates and makes speech learning easier.</p>
            </div>
            <div className="scroll-parad">
            <h3 className="pt-5o">Challenges of conventional speech therapy:</h3>
            <ul>
              <li>Availability of diligent speech therapists</li>
              <li>Limited time provision per therapist per child</li>
              <li>Expensive fees and logistical issues</li>
              <li>Demands extra attention and care</li>
              <li>NO digital tools to facilitate speech learning in India</li>
            </ul>
          </div>
          </motion.div>
        </motion.div>
      </div>

      {/* Section 1: Fixed center on screen */}
      <section className="scroll-section" ref={section1Ref}>
        <motion.div className="fixed-content" style={{ y: yTransform }}>
          <h3 className="pt-5">What is it?</h3>
          <p>
            Speaklear™ is a self learning speech training application software that
            can be used by individuals as well as speech therapists for their speech
            therapy.
          </p>
        </motion.div>
        <motion.div className="fixed-content1" style={{ y: yTransform1 }}>
          <div className="scroll-para">
            <h3 className="pt-5">Challenges of conventional speech therapy:</h3>
            <ul>
              <li>Availability of diligent speech therapists</li>
              <li>Limited time provision per therapist per child</li>
              <li>Expensive fees and logistical issues</li>
              <li>Demands extra attention and care</li>
              <li>NO digital tools to facilitate speech learning in India</li>
            </ul>
          </div>
        </motion.div>
        <img className="right_corner" src="img/logo_b.png" alt="Design" width="100" />
      </section>

      {/* Scroll-triggered lines section */}
      <section className="fixed-section">
        <div className="scroll-container">
          <ScrollLine animation={fadeInUpq}>Line One: Empower Speech</ScrollLine>
          <ScrollLine animation={fadeInLeftq}>Line Two: Enable Growth</ScrollLine>
          <ScrollLine animation={fadeInRightq}>Line Three: Speak with Confidence</ScrollLine>
        </div>
      </section>

      {/* Animated Image Section 1 */}
      <section>
        <motion.div
          ref={imageRef1}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false }}
          variants={fadeInRightq}
        >
          <img
            src="https://images.pexels.com/photos/19561297/pexels-photo-19561297.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load"
            alt="Canyon"
          />
        </motion.div>
        <motion.h2 initial="hidden" whileInView="visible" variants={fadeInUpq}>
          Canyon
        </motion.h2>
      </section>

      {/* Animated Image Section 2 */}
      <section>
        <motion.div
          ref={imageRef2}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false }}
          variants={fadeInRightq}
        >
          <img
            src="https://images.pexels.com/photos/19488566/pexels-photo-19488566/free-photo-of-kyoto.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load"
            alt="Kyoto"
          />
        </motion.div>
        <motion.h2 initial="hidden" whileInView="visible" variants={fadeInUpq}>
          Kyoto
        </motion.h2>
      </section>
    </>
  );
}

export default Productdetailsframer;
